import { render, staticRenderFns } from "./WorkflowRow.vue?vue&type=template&id=2f2436a2"
import script from "./WorkflowRow.vue?vue&type=script&lang=js"
export * from "./WorkflowRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports